export default __webpack_public_path__ + "static/media/check-icon.a55c40ba.svg";